import React, { createContext, useContext, useState, useEffect } from "react";
import {
  AUTH_PERMISSIONS,
  AUTH_PROFILE,
  AUTH_TOKEN,
} from "constants/AuthConstant";
import { API_URL } from "constants/ApiConstant";
import { get, getPaginate } from "services/ApiService";
import { useLocation } from "react-router-dom";
import { getCookie } from "services/CookieService";
import { APP_VERSION } from "configs/AppConfig";

const UserProfileContext = createContext();

export const UserProfileProvider = ({ children }) => {
  const [dataProfile, setDataProfile] = useState(null);
  const location = useLocation();

  const getProfile = async () => {
    try {
      const res = await get(API_URL.profile);
      if (res?.status === 200) {
        // Pakai functional update agar changelog yang sudah ada tidak tertimpa
        setDataProfile((prev) => ({
          ...res?.data?.data,
          changelog: prev?.changelog,
        }));
        localStorage.setItem(
          AUTH_PROFILE,
          JSON.stringify({
            ...res?.data?.data,
            company: {
              id: res?.data?.data?.current_company?.value,
              name: res?.data?.data?.current_company?.label,
            },
          }),
        );
        localStorage.setItem(
          AUTH_PERMISSIONS,
          JSON.stringify(res?.data?.data?.privileges),
        );
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const getChangelog = async () => {
    try {
      const res = await getPaginate(
        API_URL.changelog + "/datatable",
        1, // currentPage
        5, // limitData
        "&is_active=true&is_spotlight=true",
      );
      if (res?.status === 200) {
        const payload = res?.data?.data;
        const list = Array.isArray(payload) ? payload : payload?.data || [];

        console.log(list);
        // Pengaman: tetap filter di sisi client kalau backend belum mendukung filter is_spotlight
        const spotlight = list.filter((item) => item?.is_spotlight);

        setDataProfile((prev) => ({
          ...(prev || {}),
          changelog: spotlight,
        }));
      }
    } catch (error) {
      console.error("Error fetching changelog:", error);
    }
  };

  const checkSession = () => {
    const storedProfile = localStorage.getItem(AUTH_TOKEN);
    if (storedProfile) {
      getProfile();
      getChangelog();
    }
  };

  useEffect(() => {
    checkSession();
  }, [location.pathname]);

  return (
    <UserProfileContext.Provider value={dataProfile}>
      {children}
    </UserProfileContext.Provider>
  );
};

export const useGetProfile = () => {
  return useContext(UserProfileContext);
};

export const useAppVersion = () => {
  const dataProfile = useContext(UserProfileContext);
  return dataProfile?.changelog?.[0]?.name || APP_VERSION;
};
